import { articlesByTopic, popularArticles } from "./articles";
import { HELP_TOPICS } from "./topics";
import type { HelpArticle, HelpTopic } from "./types";
import { isKnowledgeObject } from "@/lib/public-knowledge-template";

export type HelpArticleCard = Pick<HelpArticle, "slug" | "topic" | "title" | "summary">;
export interface HelpDirectoryView {
  topic?: HelpTopic;
  topics: HelpTopic[];
  articles: HelpArticleCard[];
}
export function buildHelpDirectoryView(topicSlug?: string): HelpDirectoryView | null {
  const topic = topicSlug ? HELP_TOPICS.find(item => item.slug === topicSlug) : undefined;
  if (topicSlug && !topic) return null;
  return {
    ...(topic ? { topic } : {}), topics: HELP_TOPICS,
    articles: (topic ? articlesByTopic(topic.slug) : popularArticles(6)).map(
      ({ slug, topic, title, summary }) => ({ slug, topic, title, summary })),
  };
}
export function isHelpDirectoryView(value: unknown): value is HelpDirectoryView {
  return isKnowledgeObject(value) && Array.isArray(value.topics) &&
    value.topics.every(topic => isKnowledgeObject(topic) && typeof topic.slug === "string" &&
      typeof topic.titleKey === "string" && typeof topic.descriptionKey === "string") &&
    Array.isArray(value.articles) && value.articles.every(article =>
      isKnowledgeObject(article) && ["slug", "topic", "title", "summary"].every(key => typeof article[key] === "string")) &&
    (value.topic === undefined || isKnowledgeObject(value.topic) &&
      typeof value.topic.slug === "string" && typeof value.topic.titleKey === "string" &&
      typeof value.topic.descriptionKey === "string");
}
